export default __webpack_public_path__ + "static/media/logo.f8a451a3.png";